

import { useEffect, useState } from 'react';

import './DescriptionPopUp.css';
import parse from 'html-react-parser';


const DescriptionPopUp = ({ jobDescription, fnClosePopUp }) => {


    const [style, setStyle] = useState({ 
        padding: "5px 55px 5px 20px", 
        overflowY: "auto", 
        // fontSize: `{${size}px}`, 
        fontSize: "28px",
    });
   
    const [size, setSize] = useState(28);

    useEffect(() => {
        const descriptionFontSize = document.getElementById("descriptionFontSize");
        if(descriptionFontSize)
            descriptionFontSize.focus();
    }, []);

    const _setSize = (e) => {
        var newStyle = {...style};
        newStyle.fontSize = parseInt(e.target.value) + "px";
        console.log(newStyle);
        setStyle(newStyle);
        setSize(e.target.value);
        //setStyle({...style, fontSize: parseInt(e.target.value) + "px"});
    }

    const closePopUp = () => {
        fnClosePopUp(true);
    }

    return(
    <div className='popup-container' style={{ background: "#d3d3d3a6", wordBreak: 'break-word' }}>
        <div className='dialog-box'>
            <div>
                <input  name="descriptionFontSize"
                        id="descriptionFontSize"
                        type="number" 
                        value={ size } 
                        onChange={ _setSize }
                    />
                <span style={{ 
                    cursor: "pointer",
                    fontSize: "15px",
                    color: "red",
                    fontWeight: "600",
                    borderRadius: "3px",
                    border: "1px solid black",

                    padding: "0 10px",
                    marginLeft: "20px",
                    }} onClick={ closePopUp }>
                    X
                </span>
            </div>
            <div style={
                    style
                }>
                {
                    jobDescription &&
                    parse(jobDescription) 
                }
            </div>
        </div>
    </div>
    )
}

export default DescriptionPopUp;